const state = {
  mobile: false,
  width: 800,
  autoDisplay: true,
  enableComponents: false,
  actionBar: true,
  countryZoom: false,
  followEvents: false,
  sideDrawer: true,
  version: 'v1.3.1'
};

const getters = {
  generalGetMobileState(state) {
    return state.mobile;
  },
  generalGetWidthState(state) {
    return state.width;
  },
  generalGetAutoDisplay(state) {
    return state.autoDisplay;
  },
  generalGetEnableComponents(state) {
    return !state.enableComponents;
  },
  generalGetCountryZoom(state) {
    return state.countryZoom;
  },
  generalGetFollowEvents(state) {
    return state.followEvents;
  },
  generalGetSideDrawer(state) {
    return state.sideDrawer;
  },
  generalGetVersionNumber(state) {
    return state.version;
  }
};

const mutations = {
  generalUpdateMobileState(state, mobile) {
    state.mobile = mobile;
  },
  generalUpdateWidthState(state, width) {
    state.width = width;
  },
  generalUpdateAutoDisplay(state, auto) {
    state.autoDisplay = auto;
  },
  generalUpdateEnableComponents(state, hide) {
    state.enableComponents = hide;
  },
  generalUpdateCountryZoom(state, zoom) {
    state.countryZoom = zoom;
    window.setTimeout(() => {
      if (state.countryZoom) {
        state.countryZoom = false;
      }
    }, 500);
  },
  generalUpdateFollowEvents(state, follow) {
    state.followEvents = follow;
  },
  generalUpdateSideDrawer(state, drawer) {
    state.sideDrawer = drawer;
  }
};

const actions = {
  generalActionMobileState(context, mobile) {
    context.commit('generalUpdateMobileState', mobile);
  },
  generalActionWidthState(context, width) {
    context.commit('generalUpdateWidthState', width);
  },
  generalApplyFollowEvents(context, follow) {
    context.commit('generalUpdateFollowEvents', follow);
    if (follow) {
      context.dispatch('eventsInitFollowEvents');
    }
  },
  generalFollowEventsChecker(context) {
    if (context.state.followEvents) {
      context.dispatch('eventsInitFollowEvents');
    }
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
